export default class Locale_AnnouncementEditor { 
	Announcement: string = "Announcement";
	Preview: string = "Preview";
}